export default __webpack_public_path__ + "static/media/bh.d6e3bed5.svg";